/**
 * The fragment an @mention link points at (spec 137): `[@Sam Lee](#mention-<id>)`.
 * Here rather than in the tasks feature because the shared Markdown renderer
 * is what recognises one.
 */
export const MENTION_HREF_PREFIX = '#mention-';
